var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.129 44H32.8713C27.9718 44 24 47.9718 24 52.8713V107.129C24 112.028 27.9718 116 32.8713 116H127.129C132.028 116 136 112.028 136 107.129V52.8713C136 47.9718 132.028 44 127.129 44ZM32.8713 40C25.7627 40 20 45.7627 20 52.8713V107.129C20 114.237 25.7627 120 32.8713 120H127.129C134.237 120 140 114.237 140 107.129V52.8713C140 45.7627 134.237 40 127.129 40H32.8713ZM62.9834 82.4256L33.3484 109.477L30.6516 106.523L59.9882 79.7438L30.6659 53.49L33.3341 50.51L69.9384 83.2837C75.4727 88.2388 84.5274 88.2388 90.0616 83.2837L126.666 50.51L129.334 53.49L100.012 79.7438L129.348 106.523L126.652 109.477L97.0166 82.4256L92.7298 86.2638C85.6767 92.5787 74.3233 92.5787 67.2702 86.2638L62.9834 82.4256Z",
    fill: "#626569"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 136,
    cy: 44,
    r: 20,
    fill: "#FF6A59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126 43.443L133.646 51.0901L147.166 37.5703",
    stroke: "#FEFEFF",
    strokeWidth: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2b78a3fd82fda173b01c71c44561efa6.svg";
export { ForwardRef as ReactComponent };